import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Categories } from "./components/Categories";
import { BrandStrip } from "./components/BrandStrip";
import { MattressStudio } from "./components/MattressStudio";
import { WhyVisit } from "./components/WhyVisit";
import { Tips } from "./components/Tips";
import { Reviews } from "./components/Reviews";
import { Services } from "./components/Services";
import { Faq } from "./components/Faq";
import { ContactMap } from "./components/ContactMap";
import { Footer } from "./components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);

    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const el = document.querySelector(a.getAttribute("href"));
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -80 });
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      cancelAnimationFrame(frame);
      document.removeEventListener("click", onAnchor);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App min-h-screen bg-cream font-sans text-ink">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Categories />
        <BrandStrip />
        <MattressStudio />
        <WhyVisit />
        <Tips />
        <Reviews />
        <Services />
        <Faq />
        <ContactMap />
      </main>
      <Footer />
    </div>
  );
}

export default App;
